<template>
    <div class="row position-relative" ref="mainContent">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li :class="{'qf-active-nav' :activeTab === 'all'}">
                    <a href="#!"
                       @click.prevent="changeTab('all')">
                        {{$ml.get('all_trademarks')}}
                        <span class="small">({{allCounter}})</span>
                    </a>
                </li>
                <li :class="{'qf-active-nav' :activeTab === 'oppositions'}">
                    <a href="#!"
                       @click.prevent="changeTab('oppositions')">
                        {{$ml.get('oppositions')}}
                        <span class="small">({{oppositionCount}})</span>
                    </a>
                </li>
                <li :class="{'qf-active-nav' :activeTab === 'monitored'}">
                    <a href="#!"
                       @click.prevent="changeTab('monitored')">
                        {{$ml.get('monitored_trademarks')}}
                        <span class="small">({{monitoredCounter}}/{{allCounter}})</span>
                    </a>
                </li>
                <li :class="{'qf-active-nav' :activeTab === 'unmonitored'}">
                    <a href="#!"
                       @click.prevent="changeTab('unmonitored')">
                        {{$ml.get('unmonitored_trademarks')}}
                        <span class="small">({{allCounter - monitoredCounter}}/{{allCounter}})</span>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12 pb-4">
            <div class="d-flex align-items-center">
                <div v-if="activeTab == 'oppositions'">
                      <div v-if="user.roles[0] === 'ROLE_MAIN' || user.roles[0] === 'ROLE_ADMIN' || user.roles[0] === 'ROLE_WRITE'">
                        <router-link to="/dashboard/add-opposition" class="btn btn-outline-dark text-uppercase btn-sm">
                            <font-awesome-icon icon="plus"/>&nbsp;&nbsp;{{$ml.get('add')}}
                        </router-link>
                    </div>
                </div>
                <div v-else>
                      <div v-if="user.roles[0] === 'ROLE_MAIN' || user.roles[0] === 'ROLE_ADMIN' || user.roles[0] === 'ROLE_WRITE'">
                         <router-link to="/dashboard/add-brand" class="btn btn-outline-dark text-uppercase btn-sm">
                        <font-awesome-icon icon="plus"/>&nbsp;&nbsp;{{$ml.get('add')}}
                      </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 h2 pt-5 text-center" v-if="loading">
            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
        </div>

        <div class="col-12 h2 pt-5 text-center" v-else-if="error">
            {{$ml.get('general_error_msg')}}
        </div>

        <div class="col-12" v-else>
            <div class="table-responsive">
                <table class="qf-trademarks-table table qf-table">
                    <thead>
                    <tr>
                        <th>
                            <label class="qf-checkbox">
                                <input type="checkbox" @change="addAllToBulk">
                                <font-awesome-icon icon="check"/>
                            </label>
                        </th>
                        <th>{{$ml.get('opposed_trademark')}}</th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('opposition_name')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOppositions.field==='opposition_name' && sortOppositions.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOppositions.field==='opposition_name' && sortOppositions.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent.stop="showFilter('EarlierTrademark')"
                                        class="qf-filter-button d-block mx-1 js-opposition-filter"
                                        ref="filterByEarlierTrademarkHead">
                                    {{$ml.get('earlier_trademark')}}
                                </button>
                                <button type="button" @click.prevent.stop="showFilter('EarlierTrademark')"
                                        class="qf-filter-button d-block">
                                    <filter-full-icon class="qf-va-sub"
                                                      v-if="this.$route.query.earlierTrademark"></filter-full-icon>
                                    <filter-empty-icon class="qf-va-sub" v-else></filter-empty-icon>
                                </button>
                            </div>
                        </th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('owner_name')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOppositions.field==='owner_name' && sortOppositions.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOppositions.field==='owner_name' && sortOppositions.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent.stop="showFilter('Owner')"
                                        class="qf-filter-button d-block mx-1 js-opposition-filter"
                                        ref="filterByOwnerHead">
                                    {{$ml.get('owner_name')}}
                                </button>
                                <button type="button" @click.prevent.stop="showFilter('Owner')"
                                        class="qf-filter-button d-block">
                                    <filter-full-icon class="qf-va-sub"
                                                      v-if="this.$route.query.owner"></filter-full-icon>
                                    <filter-empty-icon class="qf-va-sub" v-else></filter-empty-icon>
                                </button>
                            </div>
                        </th>
                        <th>{{$ml.get('Classes')}}</th>
                        <th>
                            <div class="d-flex align-items-center">
                                <button type="button" @click.prevent="changeSort('status')"
                                        class="qf-sort-button qf-sort-order position-relative d-block">
                                    <font-awesome-icon icon="sort-up" class="qf-sort-up"
                                                       :class="{'qf-active-sort': (sortOppositions.field==='status' && sortOppositions.order === -1)}"/>
                                    <font-awesome-icon icon="sort-down" class="qf-sort-down"
                                                       :class="{'qf-active-sort': (sortOppositions.field==='status' && sortOppositions.order === 1)}"/>
                                </button>
                                <button type="button" @click.prevent.stop="showFilter('Status')"
                                        class="qf-filter-button d-block mx-1 js-opposition-filter"
                                        ref="filterByStatusHead">
                                    {{$ml.get('current_status')}}
                                </button>
                                <button type="button" @click.prevent.stop="showFilter('Status')"
                                        class="qf-filter-button d-block">
                                    <filter-full-icon class="qf-va-sub"
                                                      v-if="filterByStatusCheck.length"></filter-full-icon>
                                    <filter-empty-icon class="qf-va-sub" v-else></filter-empty-icon>
                                </button>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td colspan="12" class="text-center h5 py-3" v-if="filteredOppositions.length === 0">
                            No results found
                        </td>
                    </tr>
                    <tr v-for="opposition in filteredOppositions"
                        @click="goToDetails(opposition.id)"
                        @click.middle="goToDetails(opposition.id, true)"
                        class="qf-clickable qf-h-60px"
                        :key="`opposition${opposition.id}`">
                        <td style="width: 40px" @click.stop>
                            <label class="qf-checkbox">
                                <input type="checkbox" :value="opposition.id" v-model="bulkEditIds">
                                <font-awesome-icon icon="check"/>
                            </label>
                        </td>
                        <td>{{opposition.opposed_trademark}}</td>
                        <td>{{opposition.earlier_trademark.brand_name}}</td>
                        <td>{{opposition.owner_name}}</td>
                        <td>
                          <span v-for="(singleClass, index) in opposition.nice_classes" :key="index">
                            {{singleClass.class_num}}{{((index+1) &lt; opposition.nice_classes.length) ? ', ' : ''}}
                          </span>
                        </td>
                        <td>{{opposition.status}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-12 p-3" v-if="count > getParams.limit">
            <paginator :count="count"
                       :limit="this.$route.query.limit ? parseInt(this.$route.query.limit) : getParams.limit"
                       :offset="this.$route.query.offset ? parseInt(this.$route.query.offset) : getParams.offset"
                       @changePage="changePage"></paginator>
        </div>

        <div class="col-12">
            <button class="btn btn-warning"
                    :disabled="bulkEditIds.length === 0"
                    @click="showChangeOwnerModal= !showChangeOwnerModal">Change Owner
            </button>
        </div>

        <div class="position-absolute"
             :style="{top: `${filterByOwnerPosition.top}px`, left: `${filterByOwnerPosition.left}px`}"
             v-show="filterByOwnerPosition.showFilter"
             v-click-outside="hideFilterByOwner">
            <table-filter :selectedEl="selectedOwners" :uniqueKey="'Owner'"
                          @changeOfValue="changeFilteredValues"></table-filter>
        </div>

        <div class="position-absolute"
             :style="{top: `${filterByStatusPosition.top}px`, left: `${filterByStatusPosition.left}px`}"
             v-show="filterByStatusPosition.showFilter"
             v-click-outside="hideFilterByStatus">
            <table-filter-with-options :filterArray="uniqueStatus"  :uniqueKey="'Status'"
                          @changeOfValue="changeFilteredValues"></table-filter-with-options>
        </div>

        <div class="position-absolute"
             :style="{top: `${filterByEarlierTrademarkPosition.top}px`, left: `${filterByEarlierTrademarkPosition.left}px`}"
             v-show="filterByEarlierTrademarkPosition.showFilter"
             v-click-outside="hideFilterByEarlierTrademark">
            <table-filter :uniqueKey="'EarlierTrademark'"
                          @changeOfValue="changeFilteredValues"></table-filter>
        </div>

        <b-modal id="change-owner0modal"
                 v-model="showChangeOwnerModal"
                 title="Add File"
                 :hide-footer="true"
                 :hide-header="true">
            <change-owner :Ids="bulkEditIds"
                          :modalOpened="showChangeOwnerModal"
                          :type="'opposition'"
                          @closeModal="closeModal"
                          @changeOwners="changeOwners"></change-owner>
        </b-modal>
    </div>
</template>

<script>
    import Paginator from '../common/Paginator'
    import {clickOutside} from "../../directives/clickOutside";
    import TableFilter from "../common/TableFilter"
    import TableFilterWithOptions from "../common/TableFilterWithOptions"
    import ChangeOwner from '../common/ChangeOwner'

    export default {
        name: "OppositionReports",
        components: {
            TableFilter, ChangeOwner, Paginator, TableFilterWithOptions
        },
        directives: {
            clickOutside
        },
        data() {
            return {
                activeTab: 'oppositions',
                filterByOppositionCheck: [],
                oppositionCount: 0,
                daaas: [],
                filterByOppositionPosition: {
                    top: 0,
                    left: 0,
                    showFilter: false
                },
                filterByOwnerCheck: [],
                filterByOwnerPosition: {
                    top: 0,
                    left: 0,
                    showFilter: false
                },
                filterByStatusCheck: [],
                filterByStatusPosition: {
                    top: 0,
                    left: 0,
                    showFilter: false
                },
                filterByEarlierTrademarkCheck: [],
                filterByEarlierTrademarkPosition: {
                    top: 0,
                    left: 0,
                    showFilter: false
                },
                filters: [
                    'EarlierTrademark', 'Owner', 'Status'
                ],
                sortOppositions: {
                    order: 1,
                    field: 'opposition_name'
                },
                oppositions: [],
                uniqueStatuses: [],
                uniqueEarlierTrademarksList: [],
                allOppositions: [],
                count: 0,
                monitoredCount: 0,
                getParams: {
                    sort: {
                        field: 'uploadedAt',
                        direction: 'desc'
                    },
                    page: 1,
                    offset: 0,
                    limit: 50,
                },
                loading: false,
                error: false,
                statusLoaders: [],
                bulkEditIds: [],
                showChangeOwnerModal: false,
                selectedOwners: [],
                selectedStatuses: [],
                selectedEarlierTrademarks: [],
            }
        },
        computed: {
            user() {
                return this.$store.state.loggedUser
            },
            uniqueStatus() {
                return this.uniqueStatuses;
            },
            prepFilterOppositions() {
                let filteredOppositions = this.oppositions;
                return filteredOppositions
            },
            prepFilterAllOppositions() {
                let filteredOppositions = this.oppositions;
                if (this.filterByOppositionCheck.length) {
                    filteredOppositions = filteredOppositions.filter(obj => {
                        return this.filterByOppositionCheck.includes(obj.opposition_name);
                    });
                }
                if (this.filterByOwnerCheck.length) {
                    filteredOppositions = filteredOppositions.filter(obj => {
                        return this.filterByOwnerCheck.includes(obj.owner_name);
                    });
                }
                if (this.filterByEarlierTrademarkCheck.length) {
                    filteredOppositions = filteredOppositions.filter(obj => {
                        return this.filterByEarlierTrademarkCheck.includes(obj.owner_name);
                    });
                }
                return filteredOppositions
            },
            filteredOppositions() {
                let filteredOppositions = this.prepFilterOppositions;
                let that = this;
                switch (this.activeTab) {
                    case 'monitored':
                        filteredOppositions = filteredOppositions.filter(obj => {
                            return obj.active === true;
                        });
                        break;
                    case 'unmonitored':
                        filteredOppositions = filteredOppositions.filter(obj => {
                            return obj.active === false;
                        });
                        break;
                }
                filteredOppositions.sort((function (a, b) {
                    let nameA = a[that.sortOppositions.field] ? a[that.sortOppositions.field].toUpperCase() : ''; // ignore upper and lowercase
                    let nameB = b[that.sortOppositions.field] ? b[that.sortOppositions.field].toUpperCase() : ''; // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -that.sortOppositions.order;
                    }
                    if (nameA > nameB) {
                        return that.sortOppositions.order;
                    }
                    return 0;
                }));
                return filteredOppositions;
            },
            filteredAllOppositions() {
                let filteredOppositions = this.prepFilterAllOppositions;
                let that = this;
                switch (this.activeTab) {
                    case 'monitored':
                        filteredOppositions = filteredOppositions.filter(obj => {
                            return obj.active === true;
                        });
                        break;
                    case 'unmonitored':
                        filteredOppositions = filteredOppositions.filter(obj => {
                            return obj.active === false;
                        });
                        break;
                    case 'oppositions':
                        filteredOppositions = filteredOppositions.filter(obj => {
                            return obj.active === false;
                        });
                        break;
                }
                filteredOppositions.sort((function (a, b) {
                    let nameA = a[that.sortOppositions.field] ? a[that.sortOppositions.field].toUpperCase() : ''; // ignore upper and lowercase
                    let nameB = b[that.sortOppositions.field] ? b[that.sortOppositions.field].toUpperCase() : ''; // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -that.sortOppositions.order;
                    }
                    if (nameA > nameB) {
                        return that.sortOppositions.order;
                    }
                    return 0;
                }));
                return filteredOppositions;
            },
            monitoredCounter() {
                return this.monitoredCount;
            },
            allCounter() {
                return this.count;
            },
            pages() {
                return Math.ceil(this.count / this.getParams.limit)
            }
        },
        watch: {
            filteredOppositions(val) {
                let indexes = []
                this.bulkEditIds.forEach((item, index) => {
                    let oppositionIndex = val.findIndex(obj => {
                        return obj.id === item
                    });
                    if (oppositionIndex === -1) {
                        indexes.push(index)
                    }
                });
                for (let i = indexes.length - 1; i >= 0; i--) {
                    this.bulkEditIds.splice(indexes[i], 1);
                }
            },
            filterByEarlierTrademarkCheck(newValue, oldValue) {
                if (oldValue != newValue) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { earlierTrademark: '' }) });
                    this.$router.push({ query: Object.assign({}, this.$route.query, { earlierTrademark: newValue }) });
                }
                if (newValue.length == 0) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { earlierTrademark: '' }) });
                }
                this.getOppositions()
            },
            filterByStatusCheck(newValue) {
                this.$router.push({ query: Object.assign({}, this.$route.query, { status: '' }) });
                this.$router.push({ query: Object.assign({}, this.$route.query, { status: newValue.join('|') }) });
                this.getOppositions()
            },
            filterByOwnerCheck(newValue, oldValue) {
                if (oldValue != newValue) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { owner: '' }) });
                    this.$router.push({ query: Object.assign({}, this.$route.query, { owner: newValue }) });
                }
                if (newValue.length == 0) {
                    this.$router.push({ query: Object.assign({}, this.$route.query, { owner: '' }) });
                }
                this.getOppositions()
            }
        },
        mounted() {
            this.getOppositions()
            this.getStatuses()
            this.checkParams()
        },
        methods: {
            getOppositions(tabName = 'oppositions') {
                if (!this.loading) {
                    this.loading = true;
                    let queryParams = '';
                    let offset = 0;
                    let limit = 50;
                    if (this.$route.query.offset && this.$route.query.limit) {
                      offset = this.$route.query.offset
                      limit = this.$route.query.limit
                    } else {
                      offset = this.getParams.offset
                      limit = this.getParams.limit
                    }
                     
                    queryParams = `?offset=${offset}&limit=${limit}&tab=${tabName}`;
                    if (this.$route.query.owner) {
                        queryParams += `&owner=${this.$route.query.owner}`
                    }
                    if (this.$route.query.earlierTrademark) {
                        queryParams += `&earlier-trademark=${this.$route.query.earlierTrademark}`
                    }
                    if (this.$route.query.status) {
                        queryParams += `&status=${this.$route.query.status}`
                    }
                    this.$store.dispatch('oppositions', queryParams).then(response => {
                        this.oppositions = response.oppositions;
                        this.count = parseInt(response.count);
                        this.monitoredCount = parseInt(response.monitored_count_brands);
                        this.oppositionCount = parseInt(response.monitored_count)
                        this.loading = false;
                    }).catch(() => {
                        this.error = true;
                        this.loading = false;
                    });
                }
            },
            getStatuses() {
                this.uniqueStatuses = ['open', 'suspended', 'for_decision', 'ended'];
            },
            getAllOppositions() {
                    let queryParams = `?offset=-1&limit=-1`;
                this.$store.dispatch('oppositions', queryParams).then(response => {
                    this.allOppositions = response.oppositions;
                }).catch(() => {
                    this.error = true;
                });
            },
            closeModal() {
                this.showChangeOwnerModal = false;
            },
            changeOwners(newOwner) {
                this.bulkEditIds.forEach(item => {
                    let opposition = this.oppositions.find(obj => {
                        return obj.id === item
                    });
                    opposition.owner_name = newOwner.name
                });
                this.showChangeOwnerModal = false;
            },
            addAllToBulk(event) {
                this.bulkEditIds = [];
                if (event.target.checked) {
                    this.bulkEditIds = this.filteredOppositions.map(obj => {
                        return obj.id
                    });
                }
            },
            hideFilters(skipType = '') {
                this.filters.forEach(value => {
                    if (skipType !== value) {
                        this[`filterBy${value}Position`].showFilter = false;
                    }
                });
            },
            showFilter(type) {
                let elemRect = this.$refs[`filterBy${type}Head`].getBoundingClientRect();
                let mainRect = this.$refs.mainContent.getBoundingClientRect();
                this[`filterBy${type}Position`].top = elemRect.top - mainRect.top + elemRect.height;
                this[`filterBy${type}Position`].left = elemRect.left - mainRect.left;
                this[`filterBy${type}Position`].showFilter = !this[`filterBy${type}Position`].showFilter;
                this.hideFilters(type);
            },
            checkParams() {
                let query = this.$route.query
                if (query.owner) {
                    this.selectedOwners.push(query.owner)
                    this.changeFilteredValues(this.selectedOwners, 'Owner')
                }
            },
            changeFilteredValues(filteredArray, type) {
                this[`filterBy${type}Check`] = filteredArray;
            },
            hideFilterByOppositions() {
                if (this.filterByOppositionPosition.showFilter) {
                    this.filterByOppositionPosition.showFilter = false;
                }
            },
            hideFilterByOwner() {
                if (this.filterByOwnerPosition.showFilter) {
                    this.filterByOwnerPosition.showFilter = false;
                }
            },
            hideFilterByStatus() {
                if (this.filterByStatusPosition.showFilter) {
                    this.filterByStatusPosition.showFilter = false;
                }
            },
            hideFilterByEarlierTrademark() {
                if (this.filterByEarlierTrademarkPosition.showFilter) {
                    this.filterByEarlierTrademarkPosition.showFilter = false;
                }
            },
            changeSort(field) {
                if (this.sortOppositions.field !== field) {
                    this.sortOppositions.field = field;
                    this.sortOppositions.order = 1;
                } else {
                    this.sortOppositions.order = (this.sortOppositions.order === 1) ? -1 : 1;
                }
            },
            changeTab(tabName) {
                this.activeTab = tabName;
                let query = `/dashboard?offset=0&limit=50&tab=${tabName}`
                this.$router.push(query).catch(()=>{});
                if (tabName == 'oppositions') {
                    this.getOppositions(tabName)
                    this.$router.push(`/dashboard/oppositions`);
                } else {
                  this.getOppositions(tabName)
                }
            },
            goToDetails(id, newWindow = false) {
                if (newWindow) {
                    window.open(`/dashboard/opposition/${id}`, '_blank');
                } else {
                    this.$router.push(`/dashboard/opposition/${id}`);
                }
            },
            changeMonitoring(id) {
                if (!this.statusLoaders.includes(id)) {
                    this.statusLoaders.push(id);
                    this.$store.dispatch('monitoring', id).then(response => {
                        let oppositionIndex = this.oppositions.findIndex(obj => {
                            return obj.id === id;
                        });
                        if (oppositionIndex > -1) {
                            this.oppositions[oppositionIndex].active = response.active;
                        }
                        this.removeFromStatusLoaders(id);
                    }).catch(() => {
                        this.removeFromStatusLoaders(id);
                    })
                }
            },
            removeFromStatusLoaders(id) {
                let statusLoaderIndex = this.statusLoaders.findIndex(item => {
                    return item === id;
                });
                if (statusLoaderIndex > -1) {
                    this.statusLoaders.splice(statusLoaderIndex, 1);
                }
            },
            changePage(page) {
                if (!this.loading) {
                    let query = `/dashboard?offset=${(page - 1) * this.getParams.limit}&limit=${this.getParams.limit}`
                    if (this.$route.query.owner) {
                        query += `&owner=${this.$route.query.owner}`
                    }
                    if (this.$route.query.earlierTrademark) {
                        query += `&earlier-trademark=${this.$route.query.earlierTrademark}`
                    }
                    if (this.$route.query.status) {
                        query += `&status=${this.$route.query.status}`
                    }
                    this.$router.push(query).catch(()=>{});
                    this.getParams.offset = (page - 1) * this.getParams.limit;
                    this.getOppositions();
                }
            }
        },
    }
</script>

<style scoped>
    .qf-trademarks-table.table.qf-table thead tr th {
        font-size: 13px;
    }

    .qf-trademarks-table.table.qf-table thead tr th:nth-child(5) > div {
        min-width: 70px;
    }

    .qf-trademarks-table.table.qf-table thead tr th:nth-child(6) > div,
    .qf-trademarks-table.table.qf-table thead tr th:nth-child(8) > div {
        min-width: 80px;
    }

    .qf-trademarks-table.table.qf-table thead tr th:nth-child(7) > div {
        min-width: 60px;
    }

    .qf-trademarks-table.table.qf-table thead tr th:nth-child(9) > div {
        min-width: 120px;
    }

    .qf-trademarks-table.table.qf-table thead tr th:nth-child(9) > div,
    .qf-trademarks-table.table.qf-table thead tr th:nth-child(11) > div {
        min-width: 120px;
    }
</style>
